module.exports = __webpack_public_path__ + "static/media/Remove.780123da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Remove.svg
// module id = 2145
// module chunks = 0